import { Icon, mergeStyles, Text } from '@fluentui/react';
import { observer } from 'mobx-react';
import React from 'react';
import { ITaskStatus } from '../../API';

export interface IStatusIndicatorProps {
	status: string;
	info?: string;
	type: StatusIndicatorType;
	config: ITaskStatus[];
}

export enum StatusIndicatorType {
	Indicator,
	Badge,
	BadgeSmall,
}

const badgeClass = mergeStyles({
	padding: '0.2em 0.6em 0.3em',
	verticalAlign: 'baseline',
	borderRadius: '0.25em',
	color: '#fff',
});

const badgeSmallClass = mergeStyles({
	padding: '0.2em 0.6em 0.3em',
	verticalAlign: 'baseline',
	borderRadius: '0.25em',
	color: '#fff',
	fontSize: '11px',
});
const statusIconClass = mergeStyles({
	borderRadius: 5,
	width: 10,
	height: 10,
	display: 'inline-block',
});

const iconClass = mergeStyles({
	fontSize: 12,
	height: 12,
	width: 12,
	color: 'black',
	marginLeft: '6px',
	cursor: 'default',
});

class StatusIndicator extends React.Component<IStatusIndicatorProps> {
	render() {
		if (!this.props.status) return <></>;

		//const color = this.props.status.color || StatusIndicator.GetStatusColor(this.props.status.name);
		let color = StatusIndicator.GetStatusColor(
			this.props.status,
			this.props.config,
		);

		let icon = this.props.info ? (
			<Icon title={this.props.info} iconName="Info" className={iconClass}></Icon>
		) : (
			<></>
		);

		let indicator: React.ReactNode;

		if (this.props.type === StatusIndicatorType.Indicator) {
			indicator = (
				<Text>
					<span
						className={statusIconClass}
						style={{ backgroundColor: color }}
					></span>{' '}
					{this.props.status}
				</Text>
			);
		} else if (this.props.type === StatusIndicatorType.Badge) {
			indicator = (
				<span className={badgeClass} style={{ backgroundColor: color }}>
					{this.props.status}
				</span>
			);
		} else if (this.props.type === StatusIndicatorType.BadgeSmall) {
			indicator = (
				<span className={badgeSmallClass} style={{ backgroundColor: color }}>
					{this.props.status}
				</span>
			);
		}

		return (
			<>
				{indicator} {icon}
			</>
		);
	}

	public static CompleteColor: string = '#109618';
	public static InProgressColor: string = '#3366cc';
	public static NotStartedColor: string = '#dc3912';
	public static FutureTaskColor: string = '#B5BFB6';
	public static OnScheduleColor: string = '#3CC445';

	public static GetStatusColor(status: string, config: ITaskStatus[]) {
		var match = config.filter(
			(s) => (status || '').toLowerCase() === (s.name || '').toLowerCase(),
		)[0];
		if (match) {
			return match.color;
		} else {
			return this.GetDefaultStatusColor(status);
		}
	}

	private static GetDefaultStatusColor(status: string): string {
		switch ((status || '').toLowerCase()) {
			//Task statuses
			case 'complete':
				return StatusIndicator.CompleteColor;
			case 'in progress':
				return StatusIndicator.InProgressColor;
			case 'on schedule':
				return StatusIndicator.OnScheduleColor;

			case 'not started':
				return StatusIndicator.NotStartedColor;
			case 'future task':
				return StatusIndicator.FutureTaskColor;
			//not in use
			case 'late':
				return 'red';

			//Project statuses
			case 'on target':
				return 'rgb(107, 183, 0)'; //green
			case 'at risk':
				return '#f0ad4e'; //amber
			case 'off track':
				return 'red'; //red
			case 'done':
				return '#777'; //grey

			default:
				return '#777';
		}
	}
}

export default observer(StatusIndicator);
